<template>
  <div class="column" ref="form">
    <section>
      <b-field label="Cosa hai visto?">
        <b-input
          ref="input1"
          v-model="imdbName"
          required
          validation-message="Scrivi qualcosa!"
          @keyup.native.enter="doOkImdb"
        ></b-input>
      </b-field>
    </section>
    <section>
      <div class="buttons">
        <b-button @click="doOkImdb" type="is-primary">Vai</b-button>
      </div>
    </section>
    <section>
      <div style="cursor: pointer">
        <b-table
          :data="imdbData"
          :columns="imdbColumns"
          :striped="true"
          :paginated="true"
          :per-page="10"
          :total="total"
          :current-page.sync="page"
          :pagination-simple="false"
          :selected.sync="selected"
          @click="imdbClicked"
        />
      </div>
    </section>
  </div>
</template>

<script>
import api from "../api/api.js";
import timdb from "../api/timdb.js";
import helpers from "../helpers.js";

let emptyVal = { id: 0, Dicks: 0 };

export default {
  name: "AddVision",
  methods: {
    isoDate(date) {
      return helpers.buildIsoDate(date);
    },
    doOkImdb() {
      const loading = this.$buefy.loading.open();
      api.vision.checkImdb(this.imdbName).then((data) => {
        data = data.data;
        let imdbData = timdb.parseImdbResponse(data,true);
        if (imdbData.length == 0 && data.d.length > 0) {
          helpers.error(
            "E' probabile che imdb abbia interpretato come nome di attore quello che cercavi. Aggiungi anche l'anno nella ricerca"
          );
        } else {
          this.imdbData = imdbData;
        }
        loading.close();
      }) .catch(() => {
        helpers.error(
            "Urca, qualcosa è andato male nella ricerca"
          );
          loading.close();
        });
    },
    imdbClicked(row) {
      const loading = this.$buefy.loading.open();
      timdb
        .TmdbQuery(row.id)
        .then((data) => {
          data = data.data;
          data.Ext_show.directors_string = data.Directors.map(
            (x) => x.Name
          ).join(", ");
          let myDate = new Date();
          data.Ext_show.Date_seen = new Date(
            Date.UTC(
              myDate.getUTCFullYear(),
              myDate.getUTCMonth(),
              myDate.getUTCDate()
            )
          );
          this.imdbName = null;
          this.imdbData = [];
          loading.close();
          this.$emit("OkSearchImdb", data);
        })
        .catch((err) => {
          loading.close();
          helpers.error(err.response.data.error);
        });
    },
  },
  data() {
    return {
      selectedRow: null,
      newItem: emptyVal,
      vShow: {},
      rowData: [],
      imdbData: [],
      selected: null,
      lovs: {},
      insertQueue: "Insert",
      selectedTab: 0,
      imdbName: "",
      page: 1,
      perPage: 10,
      total: 0,
      filter: {},
      imdbColumns: [
        {
          field: "url",
          label: "",
        },
        {
          field: "title",
          label: "Titolo",
        },
        {
          field: "year",
          label: "Anno",
        },
        {
          field: "starring",
          label: "Con",
        },
      ],
    };
  },
  mounted() {},
};
</script>

<style>
</style>
